import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import { Col, Form, Row } from 'react-bootstrap';


export default function SchoolNew(props) {
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);

    
    const [organizationCode, setOrganizationCode] = useState("");
    const [schoolName, setSchoolName] = useState("");
    const [province, setProvince] = useState("");
    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [maxStudent, setMaxStudent] = useState(0);

    const addNewItem = function(){
      saveItem();
    }
           
    
    const checkDataEntry = function(){
      if((organizationCode == 0)||(organizationCode == "")||(organizationCode == null)){
            setErrorMessage("کد نوع تخفیف را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(schoolName.trim().length == 0){
            setErrorMessage("نوع تخفیف را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(province.trim().length == 0){
            setErrorMessage("نوع تخفیف را وارد کنید");
            setErorVisible(true);
            return false;
        } 
        if(city.trim().length == 0){
            setErrorMessage("نوع تخفیف را وارد کنید");
            setErorVisible(true);
            return false;
        } 
        if(address.trim().length == 0){
            setErrorMessage("نوع تخفیف را وارد کنید");
            setErorVisible(true);
            return false;
        } 
        if((maxStudent == 0)||(maxStudent == "")||(maxStudent == null)){
            setErrorMessage("کد نوع تخفیف را وارد کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveItem = function(){
      if(!checkDataEntry()) return;

      setSaving(true);
      
      var params = {login:util.getTrustedUser(), organizationCode:organizationCode, schoolName:schoolName, province:province, city:city, address:address, maxStudent:maxStudent};
      var url = config.Server+`/basic/school/create`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
 
                  setOrganizationCode("");
                  setSchoolName("");
                  setProvince("");
                  setCity("");
                  setAddress("");
                  setMaxStudent("");

                  setSaving(false);
      
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });
     }   
    
    return (
        <>
          
          <Row style={{marginTop:"20px"}} className='justify-content-center'>
            <Col md={4}>
              <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>ثبت مدرسه جدید</div>
              <Row style={{padding:"5px", marginTop:"15px"}}>
                <Col>
                    <FloatLabel>
                      <InputText value={organizationCode} onChange={(e) => setOrganizationCode(e.target.value)} keyfilter="" maxLength={8} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                      <label htmlFor="username">کد مدرسه</label>
                    </FloatLabel>
                </Col>
              </Row>
              <Row style={{padding:"5px", marginTop:"15px"}}>
                <Col>
                    <FloatLabel>
                      <InputText value={schoolName} onChange={(e) => setSchoolName(e.target.value)} keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                      <label htmlFor="username">نام مدرسه</label>
                    </FloatLabel>
                </Col>
              </Row>
              <Row style={{padding:"5px", marginTop:"15px"}}>
                <Col>
                    <FloatLabel>
                        <InputText value={province} onChange={(e) => setProvince(e.target.value)} keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                        <label htmlFor="username">استان</label>
                    </FloatLabel>                       
                </Col>
              </Row>
              <Row style={{padding:"5px", marginTop:"15px"}}>
                <Col>
                    <FloatLabel>
                      <InputText value={city} onChange={(e) => setCity(e.target.value)} keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                      <label htmlFor="username">شهر</label>
                    </FloatLabel>             
                </Col>
              </Row>
              <Row style={{padding:"5px", marginTop:"15px"}}>
                <Col>
                    <FloatLabel>
                        <InputText value={maxStudent} onChange={(e) => setMaxStudent(e.target.value)} keyfilter="int" maxLength={4} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                        <label htmlFor="username">حداکثر تعداد دانش اموز</label>
                    </FloatLabel>
                </Col>
              </Row>
              <Row style={{padding:"5px", marginTop:"15px"}}>
                <Col>
                    <FloatLabel>
                      <InputText value={address} onChange={(e) => setAddress(e.target.value)} keyfilter="" maxLength={100} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                      <label htmlFor="username">آدرس</label>
                    </FloatLabel>
                </Col>
              </Row>
              <Row style={{padding:"5px", marginTop:"15px"}}>
                <Col md={6}>
                    <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                      <Button label="ایجاد مدرسه" icon="pi pi-plus" onClick={()=>addNewItem()} severity="secondary" iconPos="right" />                    
                    </div>
                </Col>
              </Row>
              <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
              <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
              <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
              <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
              <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
            </Col>
          </Row>
          <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
   
  }

 